import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectConfig3d } from '../../../_redux-variants';
import { importPreview3d } from '../importPreview3d';
import { generateArPreviewThumbnail } from './generateArPreviewThumbnail';
import { loadGltf } from './loadGltf';
import { toArConfig } from './toArConfig';

export const prepareArPreview = async (state: PdpState) => {

    // AR Preview cannot work without a 3D configuration. At the time of writing the Gift plugin
    // is the only plugin with 3D support. To use AR Preview for your plugin, supply a valid
    // 3D configuration.
    const config3d = selectConfig3d(state as any as GiftPdpState)!;

    return {
        gltf: await loadGltf(config3d),
        preview: await generateArPreviewThumbnail(state),
        arConfig: toArConfig(config3d),
        preview3d: await importPreview3d()
    };
};